export const TOGGLE_EBRIEFING_MODAL = 'TOGGLE_EBREIFING_MODAL';

export const toggleEbriefingModal = () => async (dispatch) => {
  dispatch({
    type: TOGGLE_EBRIEFING_MODAL,
  });
};
